/** Символи без схожих між собою (0/O, 1/l/I), щоб пароль легко було передати й набрати */
const LOWER = 'abcdefghijkmnpqrstuvwxyz'
const UPPER = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
const DIGITS = '23456789'
const ALL = LOWER + UPPER + DIGITS

export const GENERATED_PASSWORD_LENGTH = 12

const randomInt = (max: number): number => {
    const buffer = new Uint32Array(1)
    globalThis.crypto.getRandomValues(buffer)
    return buffer[0]! % max
}

const pick = (alphabet: string): string => alphabet[randomInt(alphabet.length)]!

/**
 * Випадковий пароль: літери обох регістрів і цифри, щонайменше по одному символу
 * кожного виду; довжина за замовчуванням 12. Джерело випадковості — crypto.
 */
export const generatePassword = (length: number = GENERATED_PASSWORD_LENGTH): string => {
    const size = Math.max(length, 3)
    const chars = [pick(LOWER), pick(UPPER), pick(DIGITS)]
    while (chars.length < size) chars.push(pick(ALL))

    // Перемішування (Фішер–Єйтс), щоб обов'язкові символи не стояли завжди на початку
    for (let i = chars.length - 1; i > 0; i--) {
        const j = randomInt(i + 1)
        ;[chars[i], chars[j]] = [chars[j]!, chars[i]!]
    }
    return chars.join('')
}
